import { Auth } from '../scenes/auth';

export default function Signup({ next, csrf }: { next: string; csrf: string }) {
  return <Auth type="signup" next={next} csrf={csrf} />;
}

export { getServerSideProps } from './login';
